module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/avatars/team-2-af7a2bd1cac3991ecabebfd342675682.jpg";